<ul class="list-group income-list">
    @for (income of incomes; track income.id; let index = $index) {
        <li class="list-group-item">
            @if (!income.editing) {
                <span class="material-icons icon" [ngClass]="{'primary': income.primary}">{{incomeIcon(income.type)}}</span>
                <div class="meta" (click)="editIncome($event, index)">
                    <p class="title">{{income.value | currency}}</p>
                    <p class="subtitle">{{words[language]['monthly'] | titlecase}} {{income.type}}</p>
                </div>
                <div class="actions actions-1">
                    <span class="dripicons-trash text-danger" (click)="discardIncome($event, index)"></span>
                </div>
            }
            @else {
                <form [formGroup]="incomeEdit">
                    <div class="form-row">
                       <div class="form-group col">
                            <select class="form-control form-control-sm" formControlName="type">
                                @for (source of incomeSources; track source) {
                                    <option value="{{source}}">{{source}} ({{words[language]['monthly'] | lowercase}})</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col">
                            <currency-input [control]="incomeEdit.get('value')"></currency-input>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-check col">
                            <input type="checkbox" id="incomePrimary" class="form-check-input" formControlName="primary" />
                            <label class="form-check-label" for="incomePrimary">Primary</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="actions col">
                            <button type="button" class="btn btn-sm btn-link" (click)="cancelIncome($event)"><span class="text-danger">cancel</span></button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="saveIncome($event)">Save</button>
                        </div>
                    </div>
                </form>
            }
        </li>
    }
</ul>
<button (click)="addIncome($event)" title="Add Income" class="btn btn-sm btn-success add"><span class="uil-plus"></span></button>